module.exports = __webpack_public_path__ + "img/glassquality_2.85ed20e1.png";